import { isEmpty } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ERROR_ICON_PATH } from 'constants/images.constants';
import { TranslationNamespace } from 'i18n';
import { PaymentRulesViewProps, TradeMethod } from 'types';

import { DefaultPaymentOption } from '../DefaultPaymentOption';

export const DefaultPaymentRulesView: React.FC<PaymentRulesViewProps> = ({
  tradeMethods = [],
  selectedTradeMethod,
  handleSelect,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.bank_select',
  });

  if (isEmpty(tradeMethods)) {
    return (
      <div className="tw-flex tw-justify-center tw-items-center tw-bg-payment-layout-out tw-py-4 tw-px-8 tw-rounded-xl">
        <img className="tw-w-8 tw-mr-4" src={ERROR_ICON_PATH} alt="error" />
        <div className="tw-text-secondary tw-text-lg">
          {t('errors.no_methods_available')}
        </div>
      </div>
    );
  }

  return (
    <div className="tw-w-full tw-grid tw-gap-8 tw-grid-cols-1 md:tw-gap-x-5 md:tw-gap-y-16 md:tw-grid-cols-2 lg:tw-grid-cols-3">
      {tradeMethods.map((tradeMethod: TradeMethod) => {
        const { paymentType, bank, bankName, paymentTypeName, fiatCurrency } =
          tradeMethod;

        return (
          <DefaultPaymentOption
            bank={bank}
            bankName={bankName}
            paymentType={paymentType}
            paymentTypeName={paymentTypeName}
            isSelected={
              selectedTradeMethod?.paymentType === paymentType &&
              selectedTradeMethod?.bank === bank
            }
            onSelect={() => handleSelect(tradeMethod)}
            key={paymentType + bank + fiatCurrency}
          />
        );
      })}
    </div>
  );
};
